"use strict";
export var Routing = /* @__PURE__ */ ((Routing2) => {
  Routing2["DUTCH_LIMIT"] = "DUTCH_LIMIT";
  Routing2["CLASSIC"] = "CLASSIC";
  Routing2["DUTCH_V2"] = "DUTCH_V2";
  Routing2["DUTCH_V3"] = "DUTCH_V3";
  Routing2["BRIDGE"] = "BRIDGE";
  Routing2["LIMIT_ORDER"] = "LIMIT_ORDER";
  Routing2["PRIORITY"] = "PRIORITY";
  Routing2["WRAP"] = "WRAP";
  Routing2["UNWRAP"] = "UNWRAP";
  return Routing2;
})(Routing || {});
